import { getWeeksInMonth } from "@internationalized/date";
import { type AriaCalendarGridProps, useCalendarGrid, useLocale } from "react-aria";
import { type RangeCalendarState, type CalendarState } from "react-stately";

import { CalendarCell } from "./CalendarCell";

interface CalendarGridProps extends AriaCalendarGridProps {
  state: CalendarState | RangeCalendarState;
}
export function CalendarGrid({ state, ...props }: CalendarGridProps) {
  const { locale } = useLocale();
  const { gridProps, headerProps, weekDays } = useCalendarGrid(props, state);

  const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale);

  return (
    <table {...gridProps} cellPadding="0" className="w-full flex-1">
      <thead {...headerProps} className="text-body-small text-text-secondary">
        <tr>
          {weekDays.map((day, index) => (
            <th className="text-center" key={index}>
              {day}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: weeksInMonth }, (_, i) => i).map((weekIndex) => (
          <tr key={weekIndex}>
            {state
              .getDatesInWeek(weekIndex)
              .map((date, i) =>
                date ? <CalendarCell date={date} key={i} state={state} /> : <td key={i} />,
              )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
